import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RechercheFormState } from '@features/demande-remboursement/choix-dossier/store/search/search.reducers';

export const selectRechercheFormState = createFeatureSelector<RechercheFormState>('mesDossiersRechercheForm');

export const selectRechercheFormValues = createSelector(selectRechercheFormState, (state) => state.value);
export const selectRechercheFormErrors = createSelector(selectRechercheFormState, (state) => state.errors);
export const selectResetDone = createSelector(selectRechercheFormState, (state) => state.resetDone);
export const selectIsDossierEligible = createSelector(selectRechercheFormValues, (state) => state.eligible);
export const selectRechercheFormIsLoading = createSelector(selectRechercheFormState, (state) => state.isLoading);